export default __webpack_public_path__ + "static/media/signup.bda5e600.png";